import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, EnvConfig } from '@doc/core';
import { Observable } from 'rxjs';
import { ApiUrls } from '../backoffice-urls';
import { BaseResponse, EventCategoryDeleteRequest, EventCategoryGetListRequest, EventCategoryGetListResponse, EventCategoryInsertRequest } from '../models';
@Injectable({
  providedIn: 'root'
})
export class EventCategoriesService {

  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
    private http: HttpClient
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getAllEventCategories(body: EventCategoryGetListRequest) {
    const link = this.apiUrl + ApiUrls.getAllEventCategories;
    return this.http.post<EventCategoryGetListResponse>(link, body);
  }

  insertEventCategory(body: EventCategoryInsertRequest) {
    const link = this.apiUrl + ApiUrls.insertEventCategory;
    return this.http.post<BaseResponse>(link, body);
  }

  updateEventCategory(body: EventCategoryInsertRequest) {
    const link = this.apiUrl + ApiUrls.updateEventCategory;
    return this.http.post<BaseResponse>(link, body);
  }
  deleteEventCategory(body: EventCategoryDeleteRequest) {
    const link = this.apiUrl + ApiUrls.deleteEventCategory;
    return this.http.post<BaseResponse>(link, body);
  }

  getEventCategoryDetail(body: any): Observable<any> {
    const link = this.apiUrl + ApiUrls.getAllEventCategoryDetail +'/'+ body;
    return this.http.get<any>(link, body);
  }
}
